export default "__VITE_ASSET__DnXhPMCn__"